// @ts-nocheck
const TranslatorMyTasksSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default TranslatorMyTasksSkeleton